import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';

import { convertGenderList } from '../../../utils/converters/convertListWithLocalization';
import * as personalInfoReq from '../../../redux/dependentForm/personal-info-req';
import { selectDependentFormPersonalInfoErrors } from '../../../redux/dependentForm/selectors';
import {
  selectGenderTypes,
  selectNameSuffixesList,
} from '../../../redux/data/selectors';
import styles from '../styles.styl';

const mapStateToProps = state => ({
  dataValidationErrors: selectDependentFormPersonalInfoErrors(state),
  nameSuffixList: selectNameSuffixesList(state),
  rawGenderList: selectGenderTypes(state),
});

const mapDispatchToProps = {
  clearPersonalReq: personalInfoReq.actions.clear,
};

export const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(({ formatMessage, rawGenderList }) => ({
    genderList: convertGenderList(rawGenderList, formatMessage) || [],
  })),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/DependentForm/DependentPersonalInfo/enhance.js